import React from "react";
import "./Partners.css";
import "../App.css";
import "@clr/icons/clr-icons.min.css";
import '@cds/core/select/register.js';


const Partners = () => {
    return (
        <div className="text-page">
            <header className="header">
                <h1 className="SubTitle">Involved Partners</h1>
            </header>
            <main className="content">
                <div className="partners">
                    {/* Coordinator */}
                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.enea.it/" target="_blank" rel="noopener noreferrer">AGENZIA NAZIONALE PER LE NUOVE TECNOLOGIE, L'ENERGIA E LO SVILUPPO ECONOMICO SOSTENIBILE (ENEA) - Coordinator</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/en/0/03/Flag_of_Italy.svg"
                                alt="Italian Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    {/* CIRTEN Consortium */}
                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="http://www.cirten.it/" target="_blank" rel="noopener noreferrer">CIRTEN - Consorzio Interuniversitario Nazionale per la Ricerca Tecnologica Nucleare</a>
                            <div style={{ fontSize: "0.9em", color: "#666", marginTop: "5px" }}>
                                Including: Università di Pisa, Politecnico di Torino, Politecnico di Milano,
                                Alma Mater Studiorum - Università di Bologna, Università degli Studi di Roma La Sapienza
                            </div>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/en/0/03/Flag_of_Italy.svg"
                                alt="Italian Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    {/* Other Italian Partners */}
                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.ansaldonucleare.com/" target="_blank" rel="noopener noreferrer">ANSALDO NUCLEARE SPA</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/en/0/03/Flag_of_Italy.svg"
                                alt="Italian Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.crs4.it/" target="_blank" rel="noopener noreferrer">CENTRO DI RICERCA, SVILUPPO E STUDI SUPERIORI IN SARDEGNA (CRS4)</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/en/0/03/Flag_of_Italy.svg"
                                alt="Italian Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>
                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.sckcen.be/en" target="_blank" rel="noopener noreferrer">SCK CEN</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/6/65/Flag_of_Belgium.svg"
                                alt="Belgium Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.newcleo.com/" target="_blank" rel="noopener noreferrer">NEWCLEO SPA</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/en/0/03/Flag_of_Italy.svg"
                                alt="Italian Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.siet.it/" target="_blank" rel="noopener noreferrer">SOCIETA INFORMAZIONI ESPERIENZE TERMOIDRAULICHE SPA (SIET)</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/en/0/03/Flag_of_Italy.svg"
                                alt="Italian Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    <div className="partner-box">
                        <div className="partners-links">
                            <span>SINTEC SRL</span>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/en/0/03/Flag_of_Italy.svg"
                                alt="Italian Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    {/* Spanish Partners */}
                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.ciemat.es/" target="_blank" rel="noopener noreferrer">CENTRO DE INVESTIGACIONES ENERGETICAS MEDIOAMBIENTALES Y TECNOLOGICAS (CIEMAT)</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/en/9/9a/Flag_of_Spain.svg"
                                alt="Spanish Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    {/* Swedish Partners */}
                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.chalmers.se/" target="_blank" rel="noopener noreferrer">CHALMERS TEKNISKA HÖGSKOLA AB</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/en/4/4c/Flag_of_Sweden.svg"
                                alt="Swedish Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.kth.se/" target="_blank" rel="noopener noreferrer">KUNGLIGA TEKNISKA HÖGSKOLAN (KTH)</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/en/4/4c/Flag_of_Sweden.svg"
                                alt="Swedish Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.ltu.se/" target="_blank" rel="noopener noreferrer">LULEÅ TEKNISKA UNIVERSITET</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/en/4/4c/Flag_of_Sweden.svg"
                                alt="Swedish Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    {/* Belgian Partners */}
                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.vki.ac.be/" target="_blank" rel="noopener noreferrer">VON KARMAN INSTITUTE FOR FLUID DYNAMICS</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/6/65/Flag_of_Belgium.svg"
                                alt="Belgian Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    {/* German Partners */}
                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.kit.edu/" target="_blank" rel="noopener noreferrer">KARLSRUHER INSTITUT FUER TECHNOLOGIE (KIT)</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/en/b/ba/Flag_of_Germany.svg"
                                alt="German Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    {/* Dutch Partners */}
                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.nrg.eu/" target="_blank" rel="noopener noreferrer">NRG PALLAS BV</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/2/20/Flag_of_the_Netherlands.svg"
                                alt="Dutch Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    {/* Romanian Partners */}
                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.raten.ro/" target="_blank" rel="noopener noreferrer">REGIA AUTONOMA TEHNOLOGII PENTRU ENERGIA NUCLEARA - RATEN</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/7/73/Flag_of_Romania.svg"
                                alt="Romanian Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>

                    {/* Swiss Partners */}
                    <div className="partner-box">
                        <div className="partners-links">
                            <a href="https://www.psi.ch/" target="_blank" rel="noopener noreferrer">PAUL SCHERRER INSTITUT (PSI)</a>
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/f/f3/Flag_of_Switzerland.svg"
                                alt="Swiss Flag"
                                className="flag"
                                height={20}
                                width={30}
                                style={{ marginLeft: "10px" }}
                            />
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Partners;
